/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { OverflowCarousel } from '@coursera-web/cds-labs';

import { Typography2 } from '@coursera/cds-core';

import InstructorCard from 'bundles/partners-graphql/components/cds/InstructorCard';

import _t from 'i18n!nls/partners-graphql';

type Instructor = {
  id: string;
  fullName: string | null;
  photo?: string | null;
  shortName?: string | null;
  title?: string | null;
};

type Props = {
  instructors: Instructor[];
};

const styles = {
  section: css`
    padding: var(--cds-spacing-300) 0;
    display: flex;
    flex-direction: column;
    gap: var(--cds-spacing-150);
  `,
  carousel: css`
    display: flex;
    gap: var(--cds-spacing-100);
    align-items: stretch;
    padding-top: var(--cds-spacing-50);
    padding-bottom: var(--cds-spacing-50);
  `,
};

const InstructorsCarouselSection = ({ instructors }: Props) => {
  if (!instructors?.length) {
    return null;
  }

  const validInstructors = instructors
    .filter((instructor) => instructor.fullName?.trim())
    .map(({ id, fullName, photo, shortName, title }) => ({
      id,
      fullName: fullName ?? '',
      photo,
      shortName,
      title,
    }));

  if (!validInstructors.length) {
    return null;
  }

  return (
    <section css={styles.section}>
      <Typography2 component="h2" variant="subtitleLarge">
        {_t('Instructors')}
      </Typography2>
      <OverflowCarousel css={styles.carousel}>
        {validInstructors.map((instructor) => (
          <InstructorCard key={instructor.id} instructor={instructor} />
        ))}
      </OverflowCarousel>
    </section>
  );
};

export default InstructorsCarouselSection;
